import Addon from "./Addon";
import InputGroup from "./InputGroup";

InputGroup.Addon = Addon;

export default InputGroup;
